import { useEffect } from 'react'
import { formatTimestamp, humanize, SeverityBadge } from 'Main/Utils'
import { DetailField } from 'views/components/Field/DetailField'

function SecurityEventDetailModal ({ show, eventId, attempt, loading, error, onClose, onRetry }) {
  useEffect(() => {
    if (!show) return undefined

    const closeOnEscape = (keyboardEvent) => {
      if (keyboardEvent.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', closeOnEscape)
    return () => window.removeEventListener('keydown', closeOnEscape)
  }, [onClose, show])

  if (!show) return null

  return (
    <>
      <div className="modal-backdrop fade show" onClick={onClose} />
      <div className="modal fade show security-detail-modal" style={{ display: 'block' }} tabIndex="-1" role="dialog" aria-modal="true" aria-labelledby="security-event-detail-title">
        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div>
                <h5 className="modal-title" id="security-event-detail-title">Blocked Request</h5>
                <small>event #{attempt?.id || eventId}</small>
              </div>
              <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
            </div>

            <div className="modal-body">
              {loading && (
                <div className="security-detail-state" role="status">
                  <i className="fa-solid fa-circle-notch fa-spin" />
                </div>
              )}

              {!loading && error && (
                <div className="security-detail-state security-detail-error" role="alert">
                  <i className="fa-solid fa-triangle-exclamation" />
                  <span>{error}</span>
                  <button type="button" className="btn btn-sm btn-primary" onClick={onRetry}>Try again</button>
                </div>
              )}

              {!loading && !error && attempt && (
                <>
                  <section className="security-detail-summary">
                    <div>
                      <SeverityBadge severity={attempt.severity} />
                      <span className={`security-decision ${attempt.blocked ? 'is-blocked' : 'is-observed'}`}>
                        <i className={`fa-solid ${attempt.blocked ? 'fa-ban' : 'fa-eye'}`} />
                        {attempt.blocked ? 'Blocked' : 'Observed'}
                      </span>
                    </div>
                    <strong>{humanize(attempt.attack_type)}</strong>
                    <span>{formatTimestamp(attempt.creation)}</span>
                  </section>

                  <div className="security-detail-grid">
                    <DetailField label="Attack type">
                      <span>{humanize(attempt.attack_type)}</span>
                      <code>{attempt.attack_type || 'UNCLASSIFIED'}</code>
                    </DetailField>
                    <DetailField label="Category">
                      <span>{humanize(attempt.category)}</span>
                      <code>{attempt.category || 'UNCLASSIFIED'}</code>
                    </DetailField>
                    <DetailField label="Reason code">
                      <code>{attempt.reason_code || 'SECURITY_REJECTION'}</code>
                    </DetailField>
                    <DetailField label="Source IP">
                      <code>{attempt.source_ip || 'unknown'}</code>
                    </DetailField>
                    <DetailField label="Request method">
                      <span className="security-detail-method">{attempt.method || 'UNKNOWN'}</span>
                    </DetailField>
                    <DetailField label="Response status">
                      <span>{attempt.status_code || 'Unknown'}</span>
                    </DetailField>
                    <DetailField label="Request target" wide>
                      <code className="security-detail-code">{attempt.endpoint || '/'}</code>
                    </DetailField>
                    <DetailField label="User agent" wide>
                      <span className="security-detail-wrap">{attempt.user_agent || 'Not provided'}</span>
                    </DetailField>
                  </div>
                </>
              )}
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SecurityEventDetailModal
